import { render } from "./Decrement.vue?vue&type=template&id=475ea664&scoped=true"
const script = {}

import "./Decrement.vue?vue&type=style&index=0&id=475ea664&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475ea664"]])

export default __exports__